interface Address {
    address1: string
    address2: string
    city: string
    state: string
    zipCode: string
}

export const parseAddress = (address: string): Address => {
    const parts = address.split(',').map(part => part.trim())


    const address1 = parts[0] ?? ''
    const city = parts[parts.length - 3] ?? ''
    const state = parts[parts.length - 2] ?? ''
    const zipCode = parts[parts.length - 1] ?? ''

    const address2 = parts.length > 4 ? parts.slice(1, parts.length - 3).join(', ') : ''

    return { address1, address2, city, state, zipCode }
}
